module.exports = __webpack_public_path__ + "img/logo.db424698.png";